<template>
    <span>
        <b-card no-body>
        <b-card-header>
            <b-row>
                 <b-col sm="10">
                    <h3>Cadastro de Notícia</h3>
                 </b-col>
            </b-row>
        </b-card-header>
        <b-card-body>
             <b-form v-on:submit.prevent="onSubmit">
            <b-row>
              <b-col cols="12">
                <b-form-group label="Título:">
                  <b-input-group class="mb-6">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="text"
                                  class="form-control"
                                  :disabled="true"
                                  placeholder="Título"
                                  autocomplete="cpf"
                                  v-model="$v.form.titulo.$model"
                                  autofocus/>
                    <b-form-invalid-feedback id="input1LiveFeedback1">Título é obrigatório.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
               <b-col cols="12" :disabled="true">
                <label>Conteúdo:</label>
                <b-form-textarea readonly id="textarea" v-model="$v.form.texto.$model" rows="3" max-rows="6"></b-form-textarea>
              </b-col>
            </b-row>
            <br>
          <b-row>
              <b-col v-if="imagemAtual" cols="12">
                 <label>Banner:</label>
                 <div class="image-preview">
                      <img class="preview" :src="imagemAtual">
                       <br><br>
                 </div>
            </b-col>
            </b-row>
          </b-form>
        </b-card-body>
         <b-card-footer class="p-12">
          <b-row>
            <b-col md="2">
              <b-button block variant="secondary" @click="$router.go(-1)">
                <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;<span>Voltar</span>
              </b-button>
            </b-col>
          </b-row>
        </b-card-footer>
    </b-card>
    </span>
</template>

<script>
import 'v-markdown-editor/dist/v-markdown-editor.css'
import Vue from 'vue'
import AuthTemplate from '@/templates/auth/AuthTemplate'
import VueSelect from 'vue-select'
import {validationMixin} from 'vuelidate'
import {required, requiredIf} from 'vuelidate/lib/validators'
import miniToastr from 'mini-toastr'
import Editor from 'v-markdown-editor'
import SessionStorage from '@/services/session-storage'

miniToastr.init()
Vue.use(Editor)

const formShape = {
  titulo: '',
  texto: '',
  imagem: ''
}

export default {
  name: 'Cadastro',
  components: {
    AuthTemplate,
    VueSelect,
    Editor
  },
  mixins: [validationMixin],
  validations: {
    form: {
      titulo: {
        required
      },
      texto: {
        // required
      },
      imagem: {
        required: requiredIf(function (nestedModel) {
          return !this.imagemAtual
        })
      }
    }
  },
  data () {
    return {
      form: Object.assign({}, formShape),
      id: 0,
      imagemAtual: false,
      descricaoValid: null,
      custom: {
        'undo': {
          cmd: 'undo',
          className: 'fa fa-undo',
          title: 'Desfazer'
        },
        'italic': {
          cmd: 'italic',
          className: 'fa fa-italic',
          title: 'Itálico'
        },
        'link': {
          cmd: 'link',
          className: 'fa fa-link',
          title: 'Link'
        },
        'numlist': {
          cmd: 'numlist',
          className: 'fa fa-list-ol',
          title: 'Numbered List'
        },
        'bold': {
          cmd: 'bold',
          className: 'fa fa-bold',
          title: 'Bold'
        },
        'preview': {
          cmd: 'preview',
          className: 'fa fa-eye no-disable',
          title: 'Toggle Preview',
          hotkey: 'Ctrl-P',
          ready: true
        },
        'fullscreen': {
          cmd: 'fullscreen',
          className: 'fa fa-arrows-alt no-disable no-mobile',
          title: 'Toggle Fullscreen',
          hotkey: 'F11',
          ready: true
        },
        'quote': {
          title: 'Quote',
          className: 'fa fa-quote-left',
          cmd: 'quote',
          hotkey: 'Ctrl-Q'
        },
        'heading': {
          title: 'Heading',
          className: 'fa fa-header',
          cmd: 'heading',
          hotkey: 'Ctrl-H'
        },
        'image': {
          title: 'Image',
          className: 'fa fa-image',
          cmd: 'image',
          hotkey: 'Ctrl-P'
        },
        'redo': {
          cmd: 'redo',
          className: 'fa fa-repeat',
          title: 'Redo',
          hotkey: 'Ctrl-Y'
        },
        'bullist': {
          cmd: 'bullist',
          className: 'fa fa-list-ul',
          title: 'Generic List'
        }
      }
    }
  },
  mounted () {
    if (typeof this.$route.params.id !== 'undefined') {
      this.loadNoticia(this.$route.params.id)
    }
  },
  computed: {
    isValid () {
      return !this.$v.form.$anyError
    }
  },
  methods: {
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    salvar () {
      let form = this.$v.form

      let data = {
        id: this.id,
        imagem: form.imagem.$model,
        texto: form.texto.$model,
        titulo: form.titulo.$model,
        usuario_id: parseInt(SessionStorage.get('usuario'))
      }

      Vue.http.post('api/noticia', data).then(response => {
        if (response.body.success) {
          miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
          if (this.cadastroInterno) {
            miniToastr.success('Notícia salva com sucesso!', 'Sucesso!', 7000)
          } else {
            miniToastr.success(response.body.msg, 'Sucesso!', 7000)
          }

          this.$router.push({path: '/noticias'})
        } else {
          this.disable_buttons = false
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
          miniToastr.error(response.body.msg, 'Alerta', 5000)
        }
      }).catch(e => {
        console.log('Servidor está fora! ' + e)
      })
    },
    loadNoticia (id) {
      Vue.http.get('api/noticia/' + id).then(response => {
        console.log(response.body.data)
        this.form.titulo = response.body.data.titulo
        this.form.texto = response.body.data.texto
        this.imagemAtual = response.body.data.imagem
        this.id = response.body.data.id
      })
    },
    uploadDoc (evento) {
      let arquivo = evento.target.files || evento.dataTransfer.files

      if (!arquivo.length) {
        return false
      }

      let reader = new FileReader()

      reader.onload = (evento) => {
        this.$v.form.imagem.$model = evento.target.result
      }
      reader.readAsDataURL(arquivo[0])
    },
    validaForm () {
      let valid = true

      if (this.$v.form.texto.$model === '') {
        miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
        miniToastr.error('Campo texto é obrigatorio.', 'Alerta!', 5000)
        this.descricaoValid = false
        valid = false
      } else {
        this.descricaoValid = true
      }

      return valid
    },
    confirmar () {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja continuar?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.salvar()
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    onSubmit () {
      if (this.validate() && this.validaForm()) {
        this.confirmar()
      }
    },
    chkState (val) {
      const field = this.$v.form[val]
      return !field.$dirty || !field.$invalid
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style scoped>
    img.preview {
        width: 200px;
        background-color: white;
        border: 1px solid #DDD;
        padding: 5px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/noticias/NoticiaVisualizar.vue